// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-misused-promises */

import * as types from "./actionTypes";
import * as flightsPlotsApi from "../../apis/flightsPlotsApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

/*
 *  Action Creators
 *
 */

export function getExistingFlightsPlotsInFlightSuccess() {
	return { type: types.FP_GET_EXISTING_FLIGHTS_PLOTS_IN_FLIGHT };
}

export function getExistingFlightsPlotsInFieldSuccess() {
	return { type: types.FP_GET_EXISTING_FLIGHTS_PLOTS_IN_FIELD };
}

export function getExistingFlightsPlotsInTrialSuccess() {
	return { type: types.FP_GET_EXISTING_FLIGHTS_PLOTS_IN_TRIAL };
}

export function getExistingFlightsPlotsInFarmSuccess() {
	return { type: types.FP_GET_EXISTING_FLIGHTS_PLOTS_IN_FARM_SUCCESS };
}

export function createFlightsPlotsSuccess() {
	return { type: types.FP_CREATE_FLIGHTS_PLOTS };
}

export function updateFlightsPlotsSuccess() {
	return { type: types.FP_UPDATE_FLIGHTS_PLOTS_SUCCESS };
}

export function getRecutParametersSuccess() {
	return { type: types.FP_GET_RECUT_PARAMETERS_SUCCESS };
}

export function deleteDefaultViewerSettingsSuccess() {
	return { type: types.FP_DELETE_DEFAULT_VIEWER_SETTINGS_SUCCESS };
}

/*
 *  Thunks
 *
 */

export function getExistingFlightsPlotsInFlight(flightId, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.getExistingFlightsPlotsInFlight(flightId, clientId, accessToken)
				.then((res) => {
					dispatch(getExistingFlightsPlotsInFlightSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function getExistingFlightsPlotsInField(flightId, fieldId, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.getExistingFlightsPlotsInField(flightId, fieldId, clientId, accessToken)
				.then((res) => {
					dispatch(getExistingFlightsPlotsInFieldSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function getExistingFlightsPlotsInTrial(flightId, trialId, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.getExistingFlightsPlotsInTrial(flightId, trialId, clientId, accessToken)
				.then((res) => {
					dispatch(getExistingFlightsPlotsInTrialSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function getExistingFlightsPlotsInFarm(flightDate, farmId, orthoId, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.getExistingFlightsPlotsInFarm(flightDate, farmId, orthoId, clientId, accessToken)
				.then((res) => {
					dispatch(getExistingFlightsPlotsInFarmSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError());
					reject(error);
				});
		});
	};
}

export function createFlightsPlots(plotsToAdd, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.createFlightsPlots(plotsToAdd, accessToken)
				.then((res) => {
					dispatch(createFlightsPlotsSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function updateFlightsPlots(plotsToUpdate, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.updateFlightsPlots(plotsToUpdate, clientId, accessToken)
				.then((res) => {
					dispatch(updateFlightsPlotsSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function getRecutParameters(flightId, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.getRecutParameters(flightId, clientId, accessToken)
				.then((res) => {
					dispatch(getRecutParametersSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function deleteDefaultViewerSettings(id, clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return flightsPlotsApi
				.deleteDefaultViewerSettings(id, clientId, accessToken)
				.then((res) => {
					dispatch(deleteDefaultViewerSettingsSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}
